import client from './client';

/** Получить список уровней сложности упражнений */
export const getComplexityLevels = () => client.get('/complexity-levels');

/** Получить профиль студента (онбординг) */
export const getStudentProfile = () => client.get('/students/profile');

/** Сохранить профиль студента (онбординг) */
export const saveStudentProfile = (payload) => client.post('/students/profile', payload);

/** Получить типы упражнений (студентский эндпоинт) */
export const getStudentExerciseTypes = () => client.get('/student/exercises/types');

/**
 * Получить список упражнений (заголовков) с агрегатом history_status и variant_count.
 * @param {number} [typeId]
 * @param {number} [complexityLevelId]
 */
export const getStudentExercises = (typeId, complexityLevelId) => {
  const params = {};
  if (typeId) params.type_id = typeId;
  if (complexityLevelId) params.complexity_level_id = complexityLevelId;
  return client.get('/student/exercises', { params });
};

/**
 * Получить детали варианта (без поля answers).
 * Ответ: VariantDetailOut { id, exercise_id, variant, question, variants,
 *   exercise_name, exercise_task, complexity_level_id, complexity_level }
 */
export const getStudentVariant = (variantId) =>
  client.get(`/student/variants/${variantId}`);

/** Начать вариант → { history_id, variant_id } */
export const startVariant = (variantId) =>
  client.post(`/student/variants/${variantId}/start`);

/**
 * Завершить вариант → { errors_count, total_questions, correct_count, details[], motivation_message }
 */
export const completeVariant = (variantId, payload) =>
  client.post(`/student/variants/${variantId}/complete`, payload);

/** Прервать вариант (204 No Content) */
export const interruptVariant = (variantId, payload) =>
  client.post(`/student/variants/${variantId}/interrupt`, payload);

/** Получить полный текст варианта с вставленными ответами (для keyword_transform) */
export const getVariantFullText = (variantId) =>
  client.get(`/student/variants/${variantId}/full-text`);

/** Получить историю прохождения упражнений студентом */
export const getStudentHistory = (limit = 10, offset = 0) =>
  client.get('/student/history', { params: { limit, offset } });

/** Сформировать запрос на рекомендации для текущего студента (создаёт запись в БД) */
export const prepareRecommendationRequest = () =>
  client.post('/recommendation-requests/prepare/me');

/** Получить виртуальный вариант с предложениями-ошибками для данного типа упражнений */
export const getRetryErrors = (typeId) =>
  client.get('/student/retry-errors', { params: { type_id: typeId } });

/** Завершить сессию повторения ошибок */
export const completeRetryErrors = (typeId, payload) =>
  client.post('/student/retry-errors/complete', { type_id: typeId, ...payload });

// ── Устаревшие алиасы (для обратной совместимости, будут удалены) ────────────

/** @deprecated Используйте getStudentVariant */
export const getStudentExercise = (id) => client.get(`/student/exercises/${id}`);

/** @deprecated Используйте startVariant */
export const startExercise = (id) => client.post(`/student/exercises/${id}/start`);

/** @deprecated Используйте completeVariant */
export const completeExercise = (id, payload) =>
  client.post(`/student/exercises/${id}/complete`, payload);

/** @deprecated Используйте interruptVariant */
export const interruptExercise = (id, payload) =>
  client.post(`/student/exercises/${id}/interrupt`, payload);
